import { Link } from 'react-router-dom';


function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>TORQUE</h1>
        <p>Unleash Your Power</p>
        <Link to="/products">
          <button className="explore-btn">
            EXPLORE NOW <i className="fas fa-arrow-right"></i>
          </button>
        </Link>
      </div>
      <div className="container hero-container-inner">
      </div>
    </section>
  );
}

export default Hero;